import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Zoom, Keyboard } from "swiper/modules";

// Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/zoom";

import "./PhotoSection.css";

const imageContext = (require as any).context(
  "../../images",
  false,
  /\.(png|jpe?g|svg|webp)$/,
);

const allImages: Record<string, string> = {};
imageContext.keys().forEach((key: string) => {
  const fileName = key.replace("./", "");
  allImages[fileName] = imageContext(key);
});

const IMAGE_NAMES = [
  "garden-1",
  "1_zimmer1_1",
  "1_zimmer1_2",
  "1_zimmer1_3",
  "2_balkon1",
  "view-1",
  "view-2",
  "3_zimmer2_1",
  "3_zimmer2_2",
  "3_zimmer2_3",
  "3_zimmer2_4",
  "4_bad_1",
  "4_bad_2",
  "4_bad_3",
  "5_kueche1",
  "6_wohnzimmer1",
  "6_wohnzimmer2",
  "7_wein",
  "8_veranda1",
  "8_veranda2",
  "9_parking",
  "beach-1",
  "brandinchi-2",
  "sea-1",
  "sea-2",
  "horse-1",
];

const SLIDES = IMAGE_NAMES.map((name, index) => {
  const fileName = `${name}.webp`;
  return {
    id: index,
    src: allImages[fileName],
    alt: name.replace("-", " "),
  };
}).filter((slide) => slide.src);

const PhotosSection: React.FC = () => {
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <section className="section py-5">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-md-7" data-aos="fade-up">
            <h2 className="heading mb-3">Fotos</h2>
            <p className="text-muted">
              Entdecke die Schönheit unserer Ferienwohnung auf Sardinien.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12" data-aos="fade-up" data-aos-delay="200">
            <Swiper
              modules={[Pagination, Navigation, Zoom, Keyboard]}
              keyboard={{ enabled: true }}
              pagination={{ clickable: true }}
              navigation={true}
              loop={true}
              grabCursor={true}
              zoom={{
                maxRatio: 3,
                toggle: true,
              }}
              className={`photo-slider ${isZoomed ? "is-zoomed" : ""}`}
            >
              {SLIDES.map((slide) => (
                <SwiperSlide key={slide.id}>
                  <div
                    className="swiper-zoom-container" /*className="img-wrapper" */
                  >
                    <img
                      src={slide.src}
                      alt={slide.alt}
                      className="img-fluid"
                      loading="lazy"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotosSection;
